import { parse } from 'date-fns'
import { createSelector } from 'reselect'

import { getLocationActivationDate } from '../modules/selectors'

export const selectDeliveries = createSelector(
  [state => state.delivery.deliveries],
  deliveries => deliveries,
)

export const selectSelectedDate = createSelector(
  [state => state.delivery.selectedDate],
  selectedDate => selectedDate,
)

export const isSelectedDeliveryDateActive = createSelector(
  [selectSelectedDate, getLocationActivationDate],
  (selectedDate, activationDate) => {
    let comparableSelectedDate = selectedDate === undefined ? new Date() : parse(selectedDate)
    let parsedactivationDate = parse(activationDate)
    let comparableactivationDate = new Date(
      parsedactivationDate.getFullYear(),
      parsedactivationDate.getMonth(),
      parsedactivationDate.getDate(),
    )
    return comparableSelectedDate >= comparableactivationDate
  },
)
